import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';

export enum FileIconVariant {
  DEFAULT = 'default',
  FILLED = 'filled',
}

interface IFileIconProps extends IConDefaultType {
  variant?: FileIconVariant;
}

function FileIcon({ color, className, size = 24, rotate, flip, variant }: IFileIconProps) {
  const fill = color || EColorMap.gray_0;
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === FileIconVariant.DEFAULT && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7 4H10.39C10.8849 3.99982 11.3722 4.12207 11.8084 4.35587C12.2446 4.58968 12.6162 4.92776 12.89 5.34L13.41 6.11C13.5923 6.38327 13.8391 6.60742 14.1287 6.76265C14.4182 6.91787 14.7415 6.99939 15.07 7H17C18.0609 7 19.0783 7.42143 19.8284 8.17157C20.5786 8.92172 21 9.93913 21 11V16C21 17.0609 20.5786 18.0783 19.8284 18.8284C19.0783 19.5786 18.0609 20 17 20H7C5.93913 20 4.92172 19.5786 4.17157 18.8284C3.42143 18.0783 3 17.0609 3 16V8C3 6.93913 3.42143 5.92172 4.17157 5.17157C4.92172 4.42143 5.93913 4 7 4Z"
            stroke={fill}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.336 5.23725C11.0452 5.08138 10.7203 4.99988 10.3904 5L7 5C6.20435 5 5.44129 5.31607 4.87868 5.87868C4.31607 6.44129 4 7.20435 4 8V16C4 16.7956 4.31607 17.5587 4.87868 18.1213C5.44129 18.6839 6.20435 19 7 19H17C17.7956 19 18.5587 18.6839 19.1213 18.1213C19.6839 17.5587 20 16.7956 20 16V11C20 10.2044 19.6839 9.44129 19.1213 8.87868C18.5587 8.31607 17.7956 8 17 8L15.0681 8C14.5754 7.99909 14.0904 7.87681 13.6562 7.64397C13.2228 7.41162 12.8532 7.07632 12.5799 6.6676L12.057 5.89335C11.8745 5.61852 11.6268 5.39312 11.336 5.23725ZM10.39 3C11.0497 2.99982 11.6993 3.16282 12.2808 3.4745C12.8612 3.7856 13.3558 4.23518 13.7207 4.78331L14.2419 5.55499C14.333 5.69163 14.4564 5.80371 14.6012 5.88133C14.7457 5.95882 14.9071 5.99957 15.0711 6H17C18.3261 6 19.5979 6.52678 20.5355 7.46447C21.4732 8.40215 22 9.67392 22 11V16C22 17.3261 21.4732 18.5979 20.5355 19.5355C19.5979 20.4732 18.3261 21 17 21H7C5.67392 21 4.40215 20.4732 3.46447 19.5355C2.52678 18.5979 2 17.3261 2 16V8C2 6.67392 2.52678 5.40215 3.46447 4.46447C4.40215 3.52678 5.67392 3 7 3H10.39C10.3901 3 10.3899 3 10.39 3Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === FileIconVariant.FILLED && (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M5.55556 3H8.56889C9.00881 2.99984 9.44193 3.10851 9.82966 3.31633C10.2174 3.52416 10.5477 3.82468 10.7911 4.19111L11.2533 4.87556C11.4154 5.11846 11.6348 5.31771 11.8922 5.45569C12.1495 5.59367 12.4369 5.66613 12.7289 5.66667H14.4444C15.3874 5.66667 16.2918 6.04127 16.9586 6.70806C17.6254 7.37486 18 8.27923 18 9.22222V13.6667C18 14.6097 17.6254 15.514 16.9586 16.1808C16.2918 16.8476 15.3874 17.2222 14.4444 17.2222H5.55556C4.61256 17.2222 3.70819 16.8476 3.0414 16.1808C2.3746 15.514 2 14.6097 2 13.6667V6.55556C2 5.61256 2.3746 4.70819 3.0414 4.0414C3.70819 3.3746 4.61256 3 5.55556 3Z"
            fill="#ADB0B8"
          />
        </svg>
      )}
    </i>
  );
}

export default FileIcon;
